import PropTypes from 'prop-types';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './index.scss';
import CardMedia1 from './cardMedia1.png';
import CardMedia2 from './cardMedia2.jpg';
import CardMedia3 from './cardMedia3.jpg';
import CardMedia4 from './cardMedia4.jpg';
import IconTransportation from '../icon-transportation.png';
import IconInternet from '../icon-internet.png';
import IconRippleLogin from '../icon-ripple-login.png';
import IconSocialShare from '../icon-social-share.png';
import IconFun from '../icon-fun.png';
import IconQuiz from './icon-quiz.png';
import IconSelfie from './icon-selfie.png';
import SurveyPurple from './icon-survey-purple.png';
import SurveyRed from './icon-survey-red.png';
import PostPhoto from './icon-post-photo.png';
import IconShare from './icon-share.png';
import IconReview from './icon-review.png';
import SurveyOrange from './icon-survey-orange.png';

const useStyles = makeStyles((theme) => ({
  cardLg: {
    width: 275,
    height: 275,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '0.5rem 0.5rem rgba(0,0,0,.5)',
    borderRadius: '10px',
    margin: '10px auto',
  },
  cardLgContent: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: '40px!important',
  },
  cardMd: {
    width: 190,
    height: 190,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '0.5rem 0.5rem rgba(183, 164, 207,.5)',
    borderRadius: '10px',
    margin: '10px auto',
  },
  cardMdContent: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: '40px!important',
  },
  cardMd__ShadowRed: {
    boxShadow: '0.5rem 0.5rem rgba(250, 166, 160,.5)',
  },
  cardMd__ShadowOrange: {
    boxShadow: '0.5rem 0.5rem rgba(250, 193, 191,.5)',
  },
}));

const RMPSChardonnayChat = ({ navigateToApplication }) => {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.inner} />
      </div>
      <div className={styles.applyNow}>
        <p>
          Want to try—not one, but three!–Chardonnays, from a world-renowned
          wine brand? <br />
          <br />
          This summer, try three crisp Robert Mondavi Private
          Selection Chardonnays: Chardonnay, 100% Chardonnay, and Buttery
          Chardonnay. <strong>If you are 21+ AND a resident of DC, FL, IL, MD, NC, NJ, NY, PA, SC, TN, TX or VA,</strong> apply today to bring you one step closer to smelling,
          swirling, and experiencing these delightful Chardonnays.
        </p>
        <Button size='small' variant='contained' color='success' className={styles.applyNowBtn} onClick={navigateToApplication}>Event Closed!</Button>
      </div>
      <div className={styles.premiumChatterbox}>
        <h1>Premium Chatterbox Advocates* will receive:</h1>

        <Grid container justifyContent='space-between'>
          <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '10% auto',
                    width: '80%',
                  }}
                  src={CardMedia1}
                  alt='Gift Card'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              $40 GIFT CARD
              <div className={styles.cardSubTitle}>
                To redeem at a local store
              </div>
            </div>
          </Grid>
          <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '5% auto',
                    width: '60%',
                  }}
                  src={CardMedia2}
                  alt='Wine Cooler'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              WINE COOLER
              <div className={styles.cardSubTitle}>
                Because Chardonnay is best when chilled!
              </div>
            </div>
          </Grid>
          <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '10% auto',
                    width: '90%',
                  }}
                  src={CardMedia3}
                  alt='3 Wine Tumblers'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              3 WINE TUMBLERS
              <div className={styles.cardSubTitle}>
                ”I don’t like stemless glasses,” said no one ever.
              </div>
            </div>
          </Grid>
          <Grid key={4} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '25% auto',
                    width: '80%',
                  }}
                  src={CardMedia4}
                  alt='Sunglasses'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              SUNGLASSES
              <div className={styles.cardSubTitle}>
                To protect your eyes when you’re basking in the sun with a
                Chardonnay
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={styles.warningNote}>
        *Standard Chatterbox Advocates will only receive a $20 gift card. Complete
        your application activities to increase your chances of getting bumped
        up to a Premium Pack!
      </div>
      <div className={styles.programSteps}>
        <h1>What We Do And Ask of Chatterbox Program Participants</h1>
        <h2>
          We work with great brands like Robert Mondavi to give their most passionate fans the chance to try new products at home for free.
          In exchange, our brand partners like seeing you experience their products and hearing about your honest opinions throughout
          the program. That’s why the more activities you do and the higher quality they are, the higher your chances to be selected as a
          Chatterbox Advocate and receive a Chat Pack—because brands love active fans and great content.<br /><br />Read on to learn more about your activities for this event!
        </h2>

        <div className={styles.stepsContainer}>
          <div className={styles.thingsYouNeed}>
            <p className={styles.thingsLabel}>
              <CheckCircleIcon
                style={{
                  color: '#006ca4',
                  verticalAlign: 'top',
                  marginRight: '5px',
                }}
              />
              THINGS YOU’LL NEED
            </p>
            <div className={styles.thingsContainer}>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconTransportation} alt='Transportation' />
                </div>
                <p className={styles.thingText}>Transportation</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconInternet} alt='Internet' />
                </div>
                <p className={styles.thingText}>Internet</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconRippleLogin} alt='Ripple Street Login' />
                </div>
                <p className={styles.thingText}>Ripple Street Login</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconSocialShare} alt='Social Account(s)' />
                </div>
                <p className={styles.thingText}>Social Account(s)</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img
                    className={styles.funEmoji}
                    src={IconFun}
                    alt='An Enormous Sense of FUN!'
                  />
                </div>
                <p className={styles.thingText}>An Enormous Sense of FUN!</p>
              </div>
            </div>
          </div>
          <div className={styles.steps}>
            <div className={styles.stepsLi}>
              <div className={styles.numberOne}>1</div>
              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>AFTER YOU APPLY,</span>{' '}
                we’ll ask you and fellow applicants to do the following
                activities for the chance to get selected for this program.
              </p>
            </div>
            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 25%',
                          width: '50%',
                        }}
                        src={IconQuiz}
                        alt='Take Quiz'
                      />
                      <p className={styles.cardMdTitle}>
                        Take a Quiz & Share On Social
                      </p>
                      <p className={styles.cardMdDesc}>3 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconSelfie}
                        alt='Take Selfie'
                      />
                      <p className={styles.cardMdTitle}>
                        Take an In-Store Selfie
                      </p>
                      <p className={styles.cardMdDesc}>Approx. 20 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={SurveyPurple}
                        alt='Take Survey'
                      />
                      <p className={styles.cardMdTitle}>Take a Survey</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
            <div className={styles.stepsLi}>
              <div className={styles.numberTwo}>2</div>

              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>
                  IF YOU’RE SELECTED,
                </span>{' '}
                we’ll ask you and other Chatterbox Advocates to complete a
                couple activities after receiving your packs!
              </p>
            </div>

            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowRed]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={SurveyRed}
                        alt='Take Survey'
                      />
                      <p className={styles.cardMdTitle}>Take a Survey</p>
                      <p className={styles.cardMdDesc}>5 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowRed]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={PostPhoto}
                        alt='Post'
                      />
                      <p className={styles.cardMdTitle}>Post a Picture</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>

            <div className={styles.stepsLi}>
              <div className={styles.numberThree}>3</div>
              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>
                  AFTER YOU’VE TRIED THE CHARDONNAYS,
                </span>{' '}
                we’ll ask you to share your experience with us and with your
                friends and family.
              </p>
            </div>

            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconReview}
                        alt='Write Review'
                      />
                      <p className={styles.cardMdTitle}>
                        Write Product Reviews (3)
                      </p>
                      <p className={styles.cardMdDesc}>15 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconShare}
                        alt='Share on Social'
                      />
                      <p className={styles.cardMdTitle}>Share on Social</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={SurveyOrange}
                        alt='Take Survey'
                      />
                      <p className={styles.cardMdTitle}>Take a Survey</p>
                      <p className={styles.cardMdDesc}>5 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.applyNowContainer}>
        <Button size='small' variant='contained' color='success' className={styles.applyNowBtn} onClick={navigateToApplication}>Apply Now!</Button>
      </div>
      <div className={styles.footer} />
    </div>
  );
};

RMPSChardonnayChat.propTypes = {
  navigateToApplication: PropTypes.func.isRequired,
};

export default RMPSChardonnayChat;
